module.exports = __webpack_public_path__ + "img/297.4645357d.png";